import React, { useState } from "react";
import MainContainer from "../../layout/MainContainer";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteIcon from "@mui/icons-material/Delete";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

import {
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Box,
  Switch,
  Button,
  Tabs,
  Tab,
  Typography,
  DialogContent,
  TextField,
  Dialog,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import Accepted from "../../features/serviceProvider/Accepted";
import Rejected from "../../features/serviceProvider/Rejected";
import Pending from "../../features/serviceProvider/Pending";
import { Commision, Payments, ServiceProviderEarnings } from "../../features";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageRevenue = () => {
  const navigate = useNavigate();
  const [value, setValue] = useState<number>(0);
  const [open, setOpen] = useState<boolean>(false);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const label = { inputProps: { "aria-label": "Switch demo" } };

  return (
    <MainContainer>
      <div className="main_loyout">
        <div className="dashboard">
          <h1 className="mn_hdng">Revenue Management</h1>
        </div>
        <Card className="cards">
          <Box className="custom_tabs">
            {/* <Box className="flx_sc">
              <Tabs
                value={value}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto"
                aria-label="basic tabs example"
                className="custom_tabs_links"
              >
                <Tab label="Manage Payment" {...a11yProps(0)} />
                <Tab
                  label="Manage Service Provider Earnings"
                  {...a11yProps(1)}
                />
                <Tab label="Manage Commision" {...a11yProps(2)} />
              </Tabs>
            </Box> */}
            {/* <CustomTabPanel value={value} index={0}> */}
            <Payments />
            {/* </CustomTabPanel> */}
            {/* <CustomTabPanel value={value} index={1}>
              <ServiceProviderEarnings />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
              <Commision />
            </CustomTabPanel> */}
          </Box>
        </Card>
      </div>
    </MainContainer>
  );
};

export default ManageRevenue;
